import scrollTo from "@common/scroll-to";

document.querySelectorAll(".element-mediacontentblocks").forEach((el) => {
  const paginationControls = el.querySelector(".pagination-controls");

  if (!paginationControls) {
    return;
  }

  const loadButton = paginationControls.querySelector(".pagination-more");
  const hideButton = paginationControls.querySelector(".pagination-hide");

  const updatePagination = () => {
    const currentCount = Array.from(el.querySelectorAll(".block-group:not(.hidden)")).reduce((totalItems, group) => {
      return (totalItems += group.querySelectorAll(".block-item").length);
    }, 0);

    const totalCount = Array.from(el.querySelectorAll(".block-group")).reduce((totalItems, group) => {
      return (totalItems += group.querySelectorAll(".block-item").length);
    }, 0);

    paginationControls.querySelector(".pagination-current-count").textContent = currentCount;
    paginationControls.querySelector(".pagination-total-count").textContent = totalCount;

    if (currentCount === totalCount) {
      loadButton.classList.add("hidden");
      hideButton.classList.remove("hidden");
    } else {
      loadButton.classList.remove("hidden");
      hideButton.classList.add("hidden");
    }

    paginationControls.classList.remove("invisible");
  };

  loadButton.addEventListener("click", () => {
    const last = Array.from(el.querySelectorAll(".block-group:not(.hidden)")).pop();
    const next = last.nextElementSibling;
    next.classList.remove("hidden");

    scrollTo(next, 24);

    updatePagination();
  });

  hideButton.addEventListener("click", () => {
    const groups = Array.from(el.querySelectorAll(".block-group"));
    const firstGroup = groups.shift();

    groups.forEach((group) => group.classList.add("hidden"));

    scrollTo(firstGroup, 24);

    updatePagination();
  });

  updatePagination();
});
